import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-4ca46b63"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "service-charge-wrap bg-stratos pt-20 pb-20" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-title style1 text-center mb-40" }, [
  /*#__PURE__*/_createElementVNode("span", null, "SIMULATEUR"),
  /*#__PURE__*/_createElementVNode("h2", { class: "text-white" }, " votre simulation")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", {
  class: "nav nav-tabs",
  id: "myTab",
  role: "tablist"
}, [
  /*#__PURE__*/_createElementVNode("li", {
    class: "nav-item",
    role: "presentation"
  }, [
    /*#__PURE__*/_createElementVNode("button", {
      class: "nav-link active",
      id: "estimationPret-tab",
      "data-bs-toggle": "tab",
      "data-bs-target": "#estimationPret",
      type: "button",
      role: "tab",
      "aria-controls": "estimationPret",
      "aria-selected": "true"
    }, "Estimation d'envoi de colis ")
  ])
], -1))
const _hoisted_5 = {
  class: "tab-content",
  id: "myTabContent"
}
const _hoisted_6 = {
  class: "tab-pane fade show active",
  id: "estimationPret",
  role: "tabpanel",
  "aria-labelledby": "estimationPret-tab"
}
const _hoisted_7 = {
  class: "row pt-50",
  id: ""
}
const _hoisted_8 = { class: "col-lg-7" }
const _hoisted_9 = { class: "row justify-content-center mb-10" }
const _hoisted_10 = { class: "col-lg-4 col-md-4" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "send_money" }, "TYPE D'ENVOI", -1))
const _hoisted_13 = { class: "col-lg-8 col-md-8" }
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "recieved_money" }, "DISTANCE", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = { class: "col-lg-4 col-md-4" }
const _hoisted_18 = { class: "form-group" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "recieved_money" }, "POIDS DU COLIS", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-8 col-md-8" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "form-group" }, [
    /*#__PURE__*/_createElementVNode("label", { for: "recieved_money" }),
    /*#__PURE__*/_createElementVNode("button", {
      type: "submit",
      class: "btn style1 w-100 mt-3 btn-estimation"
    }, " Obtenir l'estimation ")
  ])
], -1))
const _hoisted_21 = {
  key: 0,
  class: "col-lg-5"
}
const _hoisted_22 = { class: "card mycard" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "texte-center card-head" }, "POINT DE L'ESTIMATION", -1))
const _hoisted_24 = { class: "card-body" }
const _hoisted_25 = { class: "card-subtitle mb-3 text-white" }
const _hoisted_26 = { class: "card-body-text" }
const _hoisted_27 = { class: "card-subtitle mb-3" }
const _hoisted_28 = { class: "card-body-text" }
const _hoisted_29 = { class: "card-subtitle mb-3 text-white" }
const _hoisted_30 = { class: "card-body-text2" }
const _hoisted_31 = { class: "card-subtitle mb-3" }
const _hoisted_32 = { class: "card-body-text" }
const _hoisted_33 = {
  key: 1,
  class: "col-lg-5"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card mycard" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-body" }),
  /*#__PURE__*/_createElementVNode("h6", { class: "texte-center card-head" }, "Ici, vous pouvez calculer les frais approximatifs pour recevoir vos colis au Bénin et partout dans le monde. Les valeurs calculées sont estimées et leur utilisation est référentielle. "),
  /*#__PURE__*/_createElementVNode("div", { class: "card-body" })
], -1))
const _hoisted_35 = [
  _hoisted_34
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_Form, {
                onSubmit: _ctx.checkEstimation,
                "validation-schema": _ctx.estimationSchema,
                class: "charge-form"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _hoisted_12,
                        _createVNode(_component_Field, {
                          name: "type",
                          class: "form-control shadow-none fs-md-15 text-dark bgcb fwb"
                        }, {
                          default: _withCtx(({ field }) => [
                            _createVNode(_component_Multiselect, _mergeProps({
                              class: "mltiselct",
                              options: _ctx.typeValue,
                              searchable: true,
                              "track-by": "label",
                              label: "label",
                              modelValue: field.value,
                              "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                            }, field, {
                              onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.typeChange($event))),
                              placeholder: "Sélectionner le type"
                            }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createVNode(_component_ErrorMessage, {
                        name: "type",
                        class: "text-danger fwb"
                      })
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _hoisted_15,
                        _createVNode(_component_Field, {
                          name: "distance",
                          class: "form-control shadow-none fs-md-15 text-white bgcb"
                        }, {
                          default: _withCtx(({ field }) => [
                            _createVNode(_component_Multiselect, _mergeProps({
                              class: "mltiselct",
                              options: _ctx.distanceOptions,
                              searchable: true,
                              "track-by": "label",
                              label: "label",
                              modelValue: _ctx.distanceSelect,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.distanceSelect) = $event))
                            }, field, {
                              noOptionsText: "Sélectionner d'abord un type d'envoi",
                              placeholder: "Sélectionner la distance"
                            }), null, 16, ["options", "modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createVNode(_component_ErrorMessage, {
                        name: "distance",
                        class: "text-danger fwb"
                      }),
                      _createTextVNode(),
                      _hoisted_16
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _hoisted_19,
                        _createVNode(_component_Field, {
                          name: "poids",
                          type: "number",
                          id: "recieved_money",
                          class: "form-control shadow-none fs-md-15 text-black fwb bgcw",
                          placeholder: "en g"
                        })
                      ]),
                      _createVNode(_component_ErrorMessage, {
                        name: "poids",
                        class: "text-danger fwb"
                      })
                    ]),
                    _hoisted_20
                  ])
                ]),
                _: 1
              }, 8, ["onSubmit", "validation-schema"])
            ]),
            (_ctx.type || _ctx.poids || _ctx.distance)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _hoisted_23,
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("h6", _hoisted_25, [
                        _createTextVNode("TYPE D'ENVOI : "),
                        _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.type == 1 ? "Colis postaux" : _ctx.type == 2 ? "Envois express" : _ctx.type == 3 ? "Poste aux lettres" : _ctx.type == 4 ? "Transfert et Location" : ""), 1)
                      ]),
                      _createElementVNode("h6", _hoisted_27, [
                        _createTextVNode("POIDS DU COLIS : "),
                        _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.poids) + " g", 1)
                      ]),
                      _createElementVNode("h6", _hoisted_29, [
                        _createTextVNode("DISTANCE :"),
                        _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.distance), 1)
                      ]),
                      _createElementVNode("h6", _hoisted_31, [
                        _createTextVNode("MONTANT TOTAL : "),
                        _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.montant) + " FCFA", 1)
                      ])
                    ])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_33, _hoisted_35))
          ])
        ])
      ])
    ])
  ]))
}